export default "__VITE_ASSET__29b77f48__"